// return week number of given date, assuming week 1 contains first Monday in January
export const weekNumber = (year, month, day) => {
    const monday = new Date(year, month-1, day);
    monday.setDate(monday.getDate() - monday.getDay() + 1);
    const yearStart = new Date(monday.getFullYear(), 0, 1);
    const weekNo = Math.ceil(( ( (monday - yearStart) / 86400000) + 1)/7);
    return monday.getFullYear() + "-" + weekNo;
};